<div class="main-container">
    <div class="main-page">
        <div class="prospect-detail">
            <div class="white-card">
                <div class="header-title-row">
                    <div class="header-left">
                        <img src="assets/svg/history-icon.svg" alt="Historial de etapas" class="center-svg"/>
                        <h1 class="text-semibold color-org t-24">Historial completo de etapas</h1>
                    </div>
                    <div class="header-actions">
                            <img src="assets/svg/settings-icon.svg" alt="Exportar" width="31" height="32"/>
                            <img src="assets/svg/reloadd-icon.svg" alt="Exportar" width="31" height="32"/>
                            <img src="assets/svg/filterpng-icon.svg" alt="Exportar" width="31" height="32"/>
                    </div>
                </div>
                <div class="header-stats mt-3">
                    <span>8 elementos | Se actualizó hace 5 minutos | Ordenado por última modificación</span>
                </div>
                <div class="content-area mt-5">
                    <div class="prospectos-table mh-50">
                        <table>
                            <thead>
                                <tr>
                                    <th class="checkbox-column text-center">
                                    </th>
                                    <th>
                                        <div class="d-flex align-items-center">
                                            Etapa
                                            <img src="assets/svg/arrow-down-black.svg" width="14" class="ms-1">
                                        </div>
                                    </th>
                                    <th>
                                        <div class="d-flex align-items-center">
                                            Importe
                                            <img src="assets/svg/arrow-down-black.svg" width="14" class="ms-1">
                                        </div>
                                    </th>
                                    <th>
                                        <div class="d-flex align-items-center">
                                            Probabilidad
                                            <img src="assets/svg/arrow-down-black.svg" width="14" class="ms-1">
                                        </div>
                                    </th>
                                    <th>
                                        <div class="d-flex align-items-center">
                                            Fecha de cierre
                                            <img src="assets/svg/arrow-down-black.svg" width="14" class="ms-1">
                                        </div>
                                    </th>
                                    <th>
                                        <div class="d-flex align-items-center">
                                            Ultima modificación por
                                            <img src="assets/svg/arrow-down-black.svg" width="14" class="ms-1">
                                        </div>
                                    </th>
                                    <th>
                                        <div class="d-flex align-items-center">
                                            Fecha ultima modificacion
                                            <img src="assets/svg/arrow-down-black.svg" width="14" class="ms-1">
                                        </div>
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="checkbox-column">
                                        <h4>1.</h4>
                                    </td>
                                    <td>Presentación propuesta</td>
                                    <td>CLP 2.000.000</td>
                                    <td>50%</td>
                                    <td>20/08/2025</td>
                                    <td>Sebastián Pérez</td>
                                    <td>25/07/2025</td>
                                    <td class="actions-cell">
                                        <div class="dropdown-container">
                                            <button class="dots-button">
                                                <svg class="dots-icon" viewBox="0 0 24 24">
                                                    <circle cx="12" cy="5" r="2"/>
                                                    <circle cx="12" cy="12" r="2"/>
                                                    <circle cx="12" cy="19" r="2"/>
                                                </svg>
                                            </button>
                                            <div class="dropdown-menu">
                                                <button class="dropdown-item">Modificar</button>
                                                <button class="dropdown-item">Eliminar</button>
                                                <button class="dropdown-item">Cambiar etapa</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="checkbox-column">
                                        <h4>2.</h4>
                                    </td>
                                    <td>Presentación propuesta</td>
                                    <td>CLP 10.000.000</td>
                                    <td>50%</td>
                                    <td>24/07/2025</td>
                                    <td>Sebastián Pérez</td>
                                    <td>18/07/2025</td>
                                    <td class="actions-cell">
                                        <div class="dropdown-container">
                                            <button class="dots-button">
                                                <svg class="dots-icon" viewBox="0 0 24 24">
                                                    <circle cx="12" cy="5" r="2"/>
                                                    <circle cx="12" cy="12" r="2"/>
                                                    <circle cx="12" cy="19" r="2"/>
                                                </svg>
                                            </button>
                                            <div class="dropdown-menu">
                                                <button class="dropdown-item">Modificar</button>
                                                <button class="dropdown-item">Eliminar</button>
                                                <button class="dropdown-item">Cambiar etapa</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="checkbox-column">
                                        <h4>3.</h4>
                                    </td>
                                    <td>Negociación</td>
                                    <td>CLP 8.500.000</td>
                                    <td>75%</td>
                                    <td>30/08/2025</td>
                                    <td>Carlos Méndez</td>
                                    <td>22/07/2025</td>
                                    <td class="actions-cell">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>        
</div>